import { Loader } from '@/components/UI/Loader/Loader';
import s from './FullPageLoader.module.css';

/**
 * Viewport-filling spinner for the boot path: route hydration, the lazy MSAL
 * layer and `inProgress === Startup | HandleRedirect`. Must stay in the entry
 * chunk and never be lazy-loaded — its job is covering chunk loads, so a deep
 * link would otherwise paint nothing at all.
 */
export const FullPageLoader = () => (
  <div className={s.wrapper}>
    <Loader background />
  </div>
);
